export var HolidayType;
(function (HolidayType) {
    HolidayType["HOLIDAY"] = "holiday";
    HolidayType["TOURING"] = "touring";
    HolidayType["OWNERSHIP"] = "ownership";
})(HolidayType || (HolidayType = {}));
